import { HStack } from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import {
  OrganizationGQLType,
  TAccountTypeGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { CsvDownloadButton } from 'packages/common-frontend/components/CsvDownloadButton';
import { FullDateRangePicker } from 'packages/common-frontend/components/DateRangePicker';
import { ExpensesFeesFilterMenus } from 'packages/statements/ui/ExpensesFeesFilterMenus';
import {
  ExpensesFeesTransactions,
  getLiabilityAccountTypeOptions,
  LedgerTransactionWithAccountNameAndType,
} from 'packages/statements/ui/expensesFeesUtils';

type ExpensesFeesTableHeaderProps = {
  countersigners: Pick<OrganizationGQLType, 'id' | 'name'>[];
  ledgerAccountTypes: TAccountTypeGQLType[];
  selectedAccountTypes: TAccountTypeGQLType[] | [];
  selectedCountersigners: string[] | [];
  onChangeHandler: {
    accountTypes: React.Dispatch<
      React.SetStateAction<[] | TAccountTypeGQLType[]>
    >;
    countersigners: React.Dispatch<React.SetStateAction<[] | string[]>>;
  };
  startDate: Date | null;
  endDate: Date | null;
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>;
  transactions: ExpensesFeesTransactions;
  isLoading: boolean;
};
export const ExpensesFeesTableHeader = ({
  countersigners,
  ledgerAccountTypes,
  selectedAccountTypes,
  selectedCountersigners,
  onChangeHandler,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  transactions,
  isLoading,
}: ExpensesFeesTableHeaderProps) => {
  const liabilityAccountTypeOptions = getLiabilityAccountTypeOptions(
    ledgerAccountTypes,
  );
  const csvDataRows = _.flatten(
    _.map(transactions, (transactionsForDay) => {
      return _.map(transactionsForDay, (transaction) => {
        return {
          ...transaction,
          normalizedAmount: transaction.normalizedAmount.toFixed(2),
          balance: transaction.balance.toFixed(2),
        };
      });
    }),
  );
  const csvHeaders: {
    label: string;
    key: keyof LedgerTransactionWithAccountNameAndType;
  }[] = [
    { label: 'Date', key: 'postingDate' },
    { label: 'Countersigner', key: 'organizationName' },
    { label: 'Transaction', key: 'accountName' },
    { label: 'Amount', key: 'normalizedAmount' },
    { label: 'Balance', key: 'balance' },
  ];
  return (
    <HStack spacing="50px" justify="space-between">
      <HStack spacing="1rem">
        <ExpensesFeesFilterMenus
          options={{
            accountTypes: liabilityAccountTypeOptions,
            countersigners: countersigners.map(({ id, name }) => ({
              label: name,
              value: id,
            })),
          }}
          selectedOptions={{
            accountTypes: selectedAccountTypes,
            countersigners: selectedCountersigners,
          }}
          onChange={onChangeHandler}
        />
        <FullDateRangePicker
          currentDateRange={{ startDate, endDate }}
          onSelectDateRange={(newDateRange) => {
            const [newStartDate, newEndDate] = newDateRange;
            if (newStartDate && newEndDate) {
              setStartDate(newStartDate);
              setEndDate(newEndDate);
            }
          }}
          width="xs"
        />
      </HStack>
      <CsvDownloadButton
        dataRows={csvDataRows}
        headers={csvHeaders}
        filenamePrefix="expenses-fees-ledger"
        buttonLabel="Export CSV of current view"
        dataIsLoading={isLoading}
      />
    </HStack>
  );
};
